import * as WorkersActionsTypes from './typings/WorkersActionsTypes';
import { WorkersState } from './typings/WorkersState';

const initialState: WorkersState = {
    initialized: false,
    items: [],
};

const WorkersReducer = (
    state = initialState,
    action: WorkersActionsTypes.WorkersActions
): WorkersState => {
    switch (action.type) {
        case WorkersActionsTypes.WorkersActionsTypes.SET_WORKERS:
            return { ...state, items: action.payload.items };
        case WorkersActionsTypes.WorkersActionsTypes.SET_WORKERS_INITIALIZED:
            return { ...state, initialized: action.payload.initialized };
        default:
            return state;
    }
};

export { WorkersReducer };
